import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Favorite from '@material-ui/icons/Favorite';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default function ExerciseCompleted(props) {
  const [state, setState] = React.useState({
    
  });


  return (
    <FormGroup row>
      <FormControlLabel
        control={
          <GreenCheckbox
            checked = {props.checked}
            icon={<CheckBoxOutlineBlankIcon fontSize="small" style={{color: "#A0A0A0"}} />}
            checkedIcon={<CheckBoxIcon fontSize="small" style={{color: "#00e676"}} />}
            name="checkedI"
          />
        }
      />
    </FormGroup>
  );
}
